import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {PriceFactor} from "../../store/state/order.state";
import {Observable} from "rxjs";
import {PriceFactorsFetchService} from "./price-factors-fetch.service";

@Injectable({providedIn: "root"})
export class PriceFactorsResolver implements Resolve<{ [accBody: string]: PriceFactor[]}> {

	constructor(private fetchService: PriceFactorsFetchService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<{ [accBody: string]: PriceFactor[]}> {
		return this.fetchService.fetchPriceFactors();
	}
}
